// extracted by mini-css-extract-plugin
module.exports = {"CheckIns":"CheckIns_CheckIns__3p2QO"};